export const environment = {
  production: true,
  apiBaseUrl: '/api',
  appVersion: '5.0.0-dev',
  // Whether this build ships/registers the Angular service worker (offline cache + update prompts).
  // Independent of production/envLabel: the deployed DEV site has a service worker too.
  serviceWorker: true,
  envLabel: 'PROD',
};
